export const menuItems = [
  { href: 'domu', label: 'app.menu.home' },
  { href: 'podminky', label: 'app.menu.vop' },
  { href: 'prodejny', label: 'app.menu.stores-vop' },
  { href: 'gdpr', label: 'app.menu.gdpr' },
  { href: 'kontakt', label: 'app.menu.contact' }
];
